import { useQuery } from '@tanstack/react-query';

import TaxonomiesService from '@/services/TaxonomiesService';

export const GET_ADMIN_TAXONOMIES_VERSIONS_QUERY_KEY = (customerId: number) => [
  'admin-taxonomies-versions',
  customerId,
];
export function useGetAdminTaxonomiesVersions(customerId: number) {
  const { data, isFetching } = useQuery<string[]>({
    queryKey: GET_ADMIN_TAXONOMIES_VERSIONS_QUERY_KEY(customerId),
    queryFn: () => TaxonomiesService.getAdminTaxonomiesVersions(customerId),
  });

  return {
    versions: data ?? [],
    versionsLoading: isFetching,
  };
}
